import React from 'react';
import { usePagination } from 'hooks/pagination';
import { TablePagination as DefaultTablePagination, styled } from '@mui/material';

const CustomDefaultTablePagination = styled(DefaultTablePagination)(({ theme }) => ({
  '& .MuiTablePagination-toolbar': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  '& .MuiTablePagination-selectRoot': {
    marginRight: theme.spacing(1),
  },
  '& .MuiTablePagination-actions': {
    marginLeft: theme.spacing(1),
  },
}));

type PaginationProps = {
  count: number;
  onChangePage(page: number): void;
  onChangeRowsPerPage(rows: number): void;
  currentPage?: number;
  currentRowsPerPage?: number;
};

const Pagination: React.FC<PaginationProps> = ({
  count,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
  currentRowsPerPage,
}) => {
  const { rowsPerPage, page, rowsPerPageOption, handleSetPage, handleSetRowsPerPage } = usePagination();
  const tablePage = currentPage ?? page;
  const tableRowsPerPage = currentRowsPerPage ?? rowsPerPage;

  function handlePageChange(page: number) {
    onChangePage(page);
    handleSetPage(page);
  }

  function handleRowsPerPageChange(rows: number) {
    handleSetPage(0);
    handleSetRowsPerPage(rows);
    onChangeRowsPerPage(rows);
  }

  return (
    <CustomDefaultTablePagination
      labelRowsPerPage="Registros"
      labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`}
      rowsPerPageOptions={rowsPerPageOption}
      count={count}
      rowsPerPage={tableRowsPerPage}
      page={tablePage}
      backIconButtonProps={{
        'aria-label': 'Página anterior',
      }}
      nextIconButtonProps={{
        'aria-label': 'Próxima Página',
      }}
      onPageChange={(e, page) => handlePageChange(page)}
      onRowsPerPageChange={e => handleRowsPerPageChange(parseFloat(e.target.value))}
    />
  );
};

export default Pagination;
